import React from "react";

const TableSkeleton = ({ rows = 5, columns = 8 }) => (
  <>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <tr key={rowIndex} className="border-t border-slate-100">
        {Array.from({ length: columns }).map((__, cellIndex) => (
          <td key={cellIndex} className="px-4 py-4">
            <div className="h-4 animate-pulse rounded bg-slate-100" />
          </td>
        ))}
      </tr>
    ))}
  </>
);

export default TableSkeleton;
